import React from "react";
import { motion } from "framer-motion";
import "../styles/HomePage.css";

const FootballPlayAnimation = () => {
  const lineOfScrimmage = 300;

  const offense = [
    { x: 200, y: lineOfScrimmage + 60 },
    { x: 170, y: lineOfScrimmage + 60 },
    { x: 140, y: lineOfScrimmage },
    { x: 170, y: lineOfScrimmage },
    { x: 200, y: lineOfScrimmage },
    { x: 230, y: lineOfScrimmage },
    { x: 260, y: lineOfScrimmage },
    { x: 310, y: lineOfScrimmage + 20 },
    { x: 360, y: lineOfScrimmage + 20 },
    { x: 410, y: lineOfScrimmage },
    { x: 50,  y: lineOfScrimmage },
  ];

  const defense = [
    { x: 130, y: lineOfScrimmage - 30 },
    { x: 175, y: lineOfScrimmage - 30 },
    { x: 215, y: lineOfScrimmage - 30 },
    { x: 265, y: lineOfScrimmage - 30 },
    { x: 160, y: lineOfScrimmage - 75 },
    { x: 210, y: lineOfScrimmage - 75 },
    { x: 60,  y: lineOfScrimmage - 90 },
    { x: 140, y: lineOfScrimmage - 130 },
    { x: 270, y: lineOfScrimmage - 145 },
    { x: 320, y: lineOfScrimmage - 40 },
    { x: 355, y: lineOfScrimmage - 90 },
  ];

  const routes = [
    { path: "M50,285 L50,150 L45,155 L50,150 L55,155" },
    { path: "M310,305 L270,240 L170,234 L177,240 L169.25,233.25 L178,230" },
    { path: "M360,305 L360,200 L400,150 L390,155 L400,150 L397.5,160" },
    { path: "M410,285 L410,210 L370,150 L370,160 L370,149 L379,155" },
    { path: "M220,360 L300,360 L375,320 L365,320 L375,320 L370,329" },
  ];

  return (
    <div className="football-play-wrapper">
      
      {/* 🔥 STREAK WIPE */}
      <motion.div
        className="wipe-streak"
        initial={{ x: "-150%", opacity: 0 }}
        animate={{ x: ["-150%", "150%"], opacity: [0, 1, 0] }}
        transition={{ duration: 0.6, ease: "easeInOut", delay: 0.3 }}
      />

      {/* 🔥 DARK VIGNETTE */}
      <motion.div
        className="vignette"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0.25 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />

      {/* 🔥 MAIN PLAY ANIMATION */}
      <motion.svg
        className="football-play"
        viewBox="0 80 520 340"
        preserveAspectRatio="xMidYMid meet"
        initial={{
          rotate: -35,
          scale: 1,
          opacity: 0,
          filter: "blur(8px)",
        }}
        animate={{
          rotate: [35, -55, -45, -47, 45, 35], // hype rotation ends at 0
          scale: [1, 3.2, 1.5],
          opacity: [0, 1, 1, 1],
          filter: ["blur(8px)", "blur(2px)", "blur(0px)", "blur(0px)"],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.5, 0.8, 1],
          rotate: {
            repeat: Infinity,       // loop indefinitely
            repeatType: "loop",     // repeats from start
            duration: 600, // 1 full rotation per minute
            ease: "linear",
            delay: 2,     // starts after hype
          },
        }}
      >
        {/* OFFENSE */}
        {offense.map((p, i) => (
          <text
            key={`o-${i}`}
            x={p.x}
            y={p.y}
            fill="#000"
            fontSize="24"
            fontWeight="bold"
            textAnchor="middle"
            alignmentBaseline="middle"
            style={{ fontFamily: "monospace" }}
          >
            X
          </text>
        ))}

        {/* DEFENSE */}
        {defense.map((p, i) => (
          <text
            key={`d-${i}`}
            x={p.x}
            y={p.y}
            fill="#000"
            fontSize="24"
            fontWeight="bold"
            textAnchor="middle"
            alignmentBaseline="middle"
            style={{ fontFamily: "monospace" }}
          >
            O
          </text>
        ))}

        {/* ROUTES */}
        {routes.map((r, i) => (
          <motion.path
            key={i}
            d={r.path}
            fill="transparent"
            stroke="#000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="4,2"
            initial={{ pathLength: 0, opacity: 1 }}
            animate={{ pathLength: 1 }}
            transition={{
              duration: 10,
              ease: "easeInOut",
              repeat: Infinity,
              repeatDelay: 0.5,
            }}
          />
        ))}
      </motion.svg>
    </div>
  );
};

export default FootballPlayAnimation;
